<script setup lang="ts">
import { TooltipProvider } from 'reka-ui'

/**
 * Mount once at the app shell. It owns the shared hover-delay state so moving
 * between adjacent toolbar buttons shows the second tooltip immediately instead
 * of restarting the delay — the behaviour that makes a dense action bar usable.
 */

withDefaults(
  defineProps<{
    delayMs?: number
    skipDelayMs?: number
  }>(),
  { delayMs: 400, skipDelayMs: 300 },
)
</script>

<template>
  <TooltipProvider :delay-duration="delayMs" :skip-delay-duration="skipDelayMs">
    <slot />
  </TooltipProvider>
</template>
